// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld/base/core';
import './layerControlWidget';

/**
 * @class Provides a legend for GeoServer backed layers.
 * @name OgcLegendLayerControlWidget
 * @constructor
 * @extends {LayerControlWidget}
 */
myw.OgcLegendLayerControlWidget = myw.ILayerControlWidget.extend({
    tagName: 'div',
    className: 'ogc-legend',

    events: {
        click: 'noop'
    },

    render() {
        const layer = this.options.layer;
        const ds = layer.datasource;

        ds.ensureLoggedIn()
            .then(() => ds.getLegendInfo(layer.layerDef))
            .then(urls => {
                for (let url of urls) {
                    this.$el.append(`<div><img src="${url}"/></div>`);
                }
            })
            .catch(reason => {
                myw.trace('ogc', 1, 'Unable to obtain legends : ', reason);
                return [];
            });
    },

    noop(ev) {
        ev.stopPropagation();
    }
});

export default myw.OgcLegendLayerControlWidget;
